import { InfluencerProfileOverview, InfluencerProfileOverviewProps } from '../shared';

type InfluencerDouyinProfileOverviewProps = InfluencerProfileOverviewProps;

export const InfluencerDouyinProfileOverview = (props: InfluencerDouyinProfileOverviewProps) => (
  <InfluencerProfileOverview {...props} />
);
